import { tieneValor, formatear } from './catalogo';
import { fechaDetalle } from './detalleVenta';

const numero = valor => tieneValor(valor) && Number.isFinite(Number(valor)) ? Number(valor) : null;
const texto = valor => tieneValor(valor) ? String(valor).trim() : 'No registrado';
const dinero = valor => valor === null ? 'No registrado' : 'RD$ ' + formatear(valor, 'moneda');
const centavos = valor => numero(valor) === null ? null : Math.round(Number(valor) * 100);
const campo = (titulo, valor) => ({ titulo, valor: texto(valor) });
const DENOMINACIONES = [2000, 1000, 500, 200, 100, 50, 25, 20, 10, 5, 1];
const VENTAS = [
  ['venta_boletos', 'Ventas de boletos (a clientes)', 1],
  ['compra_boletos', 'Compra de boletos (a choferes)', -1],
  ['venta_envios', 'Ventas de envios', 1],
  ['deposito', 'Deposito de caja (menudos)', 1],
  ['otras_ventas', 'Otras ventas', 1],
  ['pagos_recibidos', 'Pagos recibidos de otras sucursales', 1],
  ['pagos_enviados', 'Pagos enviados a otras sucursales', -1],
  ['sobrante_usuario_anterior', 'Sobrante usuario anterior', 1],
];

export function detalleCierre(datos = {}) {
  const r = datos.registro || {}, d = datos.detalles || {}, conteo = d.conteo || {};
  const estadisticas = d.estadisticas || {};
  const vendidos = numero(estadisticas.cantidad_vendidos), pendientes = numero(estadisticas.cantidad_sin_abordar);
  const montoVendidos = centavos(estadisticas.monto_vendidos), montoPendientes = centavos(estadisticas.monto_sin_abordar);
  const denominaciones = DENOMINACIONES.map(valor => {
    const cantidad = numero(conteo[String(valor)]);
    return { valor, cantidad: texto(cantidad), monto: dinero(cantidad === null ? null : valor * cantidad) };
  });
  const ventas = VENTAS.map(([clave, titulo, signo]) => ({ titulo, signo: signo > 0 ? '+' : '-', valor: dinero(numero(r[clave])) }));
  // Use cents so exact cash counts do not appear as a floating-point shortage/surplus.
  const total = VENTAS.every(([clave]) => centavos(r[clave]) !== null)
    ? VENTAS.reduce((sum, [clave, , signo]) => sum + signo * centavos(r[clave]), 0) : null;
  const efectivo = centavos(r.efectivo);
  const diferencia = efectivo !== null && total !== null ? efectivo - total : null;
  const estado = diferencia === null ? 'No disponible' : diferencia === 0 ? 'Cuadrado' : diferencia > 0 ? 'Sobrante' : 'Faltante';
  const boletos = [
    { titulo: 'Vendidos', cantidad: texto(vendidos), monto: dinero(montoVendidos === null ? null : montoVendidos / 100) },
    { titulo: 'Abordados', cantidad: texto(vendidos === null || pendientes === null ? null : vendidos - pendientes),
      monto: dinero(montoVendidos === null || montoPendientes === null ? null : (montoVendidos - montoPendientes) / 100) },
    { titulo: 'Sin abordar', cantidad: texto(pendientes), monto: dinero(montoPendientes === null ? null : montoPendientes / 100) },
  ];
  return {
    cabecera: [campo('Num. cierre', r.secuencia), campo('Num. caja', r.caja),
      campo('Fecha', fechaDetalle(conteo.fecha || r.fecha || r.fechacierre, true)), campo('Usuario', r.cajero)],
    nombreCaja: tieneValor(r.nombre_caja) ? texto(r.nombre_caja) : '',
    pagos: [
      { titulo: 'Tarjeta', cantidad: texto(r.cantidadtarjeta), monto: dinero(numero(r.tarjeta)) },
      { titulo: 'Cheque', cantidad: texto(r.cantidadcheques), monto: dinero(numero(r.cheques)) },
    ],
    denominaciones, ventas, boletos, efectivo: dinero(efectivo === null ? null : efectivo / 100),
    total: dinero(total === null ? null : total / 100), estado,
    diferencia: dinero(diferencia === null ? null : Math.abs(diferencia) / 100),
  };
}
